import React, { Component } from 'react';
import { Container, Row, Col, Input, Table, Button } from 'reactstrap';
import { Typeahead } from 'react-bootstrap-typeahead';
import authService from '../api-authorization/AuthorizeService';
import AdminFunctions from './AdminFunctions';
import utilities from '../util/utilities';
import { FaSort } from 'react-icons/fa'
import '../layout/site.css';

export class Users extends Component {
    static displayName = Users.name;

    constructor(props) {
        super(props);

        this.state = {
            users: [],
            search: null,
            locationOptions: [],
            location: [],
            height: 0,
            width: 0,
            sort: {
                column: null,
                direction: 'desc'
            },
        };

        window.addEventListener('resize', this.setWindowDimensions);

    }

    async componentDidMount() {
        const isAdmin = AdminFunctions.isAdminAsync();
        if (!isAdmin) {
            this.props.history.push('/accessdenied');
        }
        this.setWindowDimensions();
        this.getLocationDropdown();
        this.getUsers();
    }

    render() {
        return (
            <div>
                <Container className='container-main' style={{ cursor: 'pointer' }}>
                    <Row>
                        <Col>
                            <h3>Users</h3>
                        </Col>
                    </Row>
                    <Row className='row-20'>
                        <Col xl='6' lg='6' md='6' sm='12' xs='12'>
                            <Input
                                type='text'
                                onChange={(e) => this.setState({ search: e.target.value })}
                                name='search'
                                id='search'
                                placeholder='Search First Name, Last Name, Email or Phone'
                                style={this.state.width < utilities.dimensions.LG ? { marginBottom: '20px' } : {}}
                            />
                        </Col>
                        <Col xl='4' lg='4' md='6' sm='12' xs='12'>
                            <Typeahead
                                id='client'
                                onChange={(selected) => this.setState({ location: selected })}
                                selected={this.state.location}
                                options={this.state.locationOptions}
                                placeholder='Search Location'
                                style={this.state.width < utilities.dimensions.MD ? { marginBottom: '20px' } : {}}
                            />
                        </Col>
                        <Col xl='1' lg='1' md='2' sm='2' xs='2'>
                            <Button
                                color='primary'
                                onClick={() => this.searchUsers()}
                            >
                                Search
                            </Button>
                        </Col>
                        <Col xl='1' lg='1' md='2' sm='2' xs='2'>
                            <Button
                                color='primary'
                                onClick={() => this.props.history.push({ pathname: '/admin/users/details', state: { existingUser: false } })}
                                style={{ whiteSpace: 'nowrap' }}
                            >
                                + Add
                            </Button>
                        </Col>
                    </Row>
                    <Row className='row-20'>
                        <Col>
                            <Table bordered hover>
                                <thead>
                                    <tr>
                                        <th>
                                            Last Name
                                            <FaSort
                                                color={this.state.sort.column === 'lastName' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('lastName')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            First Name
                                            <FaSort
                                                color={this.state.sort.column === 'firstName' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('firstName')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            Location
                                            <FaSort
                                                color={this.state.sort.column === 'location' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('client')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            Office Phone
                                            <FaSort
                                                color={this.state.sort.column === 'officePhone' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('officePhone')}
                                                className='sort-button'
                                            />
                                        </th>
                                        <th>
                                            Email
                                            <FaSort
                                                color={this.state.sort.column === 'email' ? '#0a58ca' : 'black'}
                                                onClick={() => this.handleSort('email')}
                                                className='sort-button'
                                            />
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {this.state.users.length > 0 && this.state.users.map((user, i) => {
                                        return (
                                            <tr
                                                key={user.id}
                                                onClick={() => this.handleRowClick(user.id)}
                                            >
                                                <td>{user.lastName}</td>
                                                <td>{user.firstName}</td>
                                                <td>{user.location}</td>
                                                <td>{user.officePhone}</td>
                                                <td>{user.email}</td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </Table>
                        </Col>
                    </Row>
                </Container>
            </div>
        )
    }

    async getLocationDropdown() {
        const token = await authService.getAccessToken();
        const response = await fetch(`api/Locations/GetDropdown`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({ locationOptions: data });
    }

    async getUsers() {
        const token = await authService.getAccessToken();
        const response = await fetch(`api/Admin/GetUsersAsync`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({ users: data });
    }

    async searchUsers() {
        var query = "";
        if (this.state.search !== undefined && this.state.search !== null && this.state.search !== "" && this.state.search.length !== 0) {
            query = this.state.search;
        }
        if (this.state.location !== undefined && this.state.location !== null && this.state.location.length !== 0) {
            query = this.state.location[0].label;
        }

        const token = await authService.getAccessToken();
        const response = await fetch(`api/Admin/SearchUsersAsync?query=${query}`, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` }
        });
        const data = await response.json();
        this.setState({ users: data });
    }

    handleRowClick(userId) {
        this.props.history.push({
            pathname: '/admin/users/details',
            state: { userId: userId, existingUser: true }
        })
    }

    setWindowDimensions = () => {
        this.setState({
            height: window.innerHeight,
            width: window.innerWidth
        });
    };

    // table sort

    handleSort(column) {
        const direction = this.state.sort.column ? (this.state.sort.direction === 'asc' ? 'desc' : 'asc') : 'desc';
        const data = this.state.users;
        data.sort((a, b) => a[column].localeCompare(b[column]))
        if (direction === 'desc') {
            data.reverse();
        }
        this.setState({
            users: data,
            sort: {
                column,
                direction
            }
        })
    };

}